import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "projects/tilmanagement/src/environments/environment";
import { TechnicalLetter } from "../../interfaces/technical-letters/technical-letters.models";
import { Observable } from "rxjs";
import { EditTechnicalLetter } from "../../interfaces/technical-letters/edit-technical-letter.models";
import { LetterEquipment } from "../../interfaces/technical-letters/letter-equipment.models";
import { UpdateLetterEquipment } from "../../interfaces/technical-letters/update-letter-equipment.models";
import { Equipment } from "../../interfaces/technical-letters/add-equipment.models";
import { Log } from "../../interfaces/technical-letters/log.models";
import { LetterHistory } from "../../interfaces/technical-letters/letter-history.models";
import { LetterEquipmentHistory } from "../../interfaces/technical-letters/letter-equipment-history.models";
import { LetterEquipmentDoc } from "../../interfaces/technical-letters/letter-equipment-doc.models";

@Injectable({
  providedIn: "root",
})
export class TechnicalLetterService {
  baseUrl = environment.apiUrl + "/technical-letters";

  constructor(private http: HttpClient) { }

  getAllStatuses(issuerId: number = 0) {
    return this.http.get<any[]>(`${this.baseUrl}/statuses?issuerId=${issuerId}`);
  }
  getAllCategories(issuerId: number = 0) {
    return this.http.get<any[]>(`${this.baseUrl}/categories?issuerId=${issuerId}`);
  }
  addTechnicalLetter(formData: FormData) {
    return this.http.post(`${this.baseUrl}`, formData);
  }
  getTechnicalLettersPaged(
    pageNumber: number,
    pageSize: number,
    filters: any = {},
    searchText: string = '',
    sortColumn: string = '',
    sortDirection: string = ''
  ) {
    let params: any = {
      pageNumber,
      pageSize,
      searchText,
      sortColumn,
      sortDirection
    };
    Object.keys(filters).forEach(key => {
      if (filters[key]) params[key] = filters[key];
    });
    return this.http.get<any>(`${environment.apiUrl}/technical-letters`, { params });
  }
  searchTurbines(params?: any): Observable<TechnicalLetter[]> {
    return this.http.get<TechnicalLetter[]>(this.baseUrl, { params });
  }
  getTechnicalLetterById(id: number): Observable<EditTechnicalLetter> {
    return this.http.get<EditTechnicalLetter>(`${this.baseUrl}/${id}`);
  }
  updateTechnicalLetter(letter: FormData): Observable<any> {
    return this.http.put(`${environment.apiUrl}/technical-letters/update-letter`, letter);
  }
  deleteTechnicalLetter(id: number, deletedBy: string): Observable<any> {
    return this.http.delete(`${environment.apiUrl}/technical-letters/delete-letter/${id}`, {
      headers: {
        'Deleted-By': deletedBy
      }
    });
  }
  getLetterEquipmentByLetterId(id: number): Observable<LetterEquipment[]> {
    return this.http.get<LetterEquipment[]>(`${environment.apiUrl}/letter-equipment/get-by-letterId/${id}`);
  }
  updateLetterEquipment(equipment: any): Observable<any> {
    return this.http.put(`${environment.apiUrl}/letter-equipment/update`, equipment);
  }
  addLetterEquipment(payload: { letterId: number; equipmentList: { equipmentType: string; equipmentNumber: string; }[]; userName: string }): Observable<any> {
    return this.http.post(`${environment.apiUrl}/letter-equipment/add`, payload);
  }
  deleteLetterEquipment(id: number, deletedBy: string): Observable<any> {
    return this.http.delete(`${environment.apiUrl}/letter-equipment/delete/${id}`, {
      headers: {
        'Deleted-By': deletedBy
      }
    });
  }
  getEquipmentLists(): Observable<Equipment[]> {
    return this.http.get<Equipment[]>(`${environment.apiUrl}/letter-equipment`);
  }
  getDeletedEquipmentLogs(letterId: number): Observable<Log[]> {
    return this.http.get<Log[]>(`${environment.apiUrl}/letters/deleted-equipment-logs/${letterId}`);
  }
  getLetterHistory(letterId: number): Observable<LetterHistory[]> {
    return this.http.get<LetterHistory[]>(`${environment.apiUrl}/letter-history/${letterId}`);
  }
  getLetterEquipmentHistory(id: number): Observable<LetterEquipmentHistory[]> {
    return this.http.get<LetterEquipmentHistory[]>(`${environment.apiUrl}/letter-equipment-history/${id}`);
  }

  UploadFileOnSharepoint(file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post(`${environment.apiUrl}/technical-letters/upload-file`, formData);
  }

  getLetterEquipmentDoc(letterEquipmentId: number): Observable<LetterEquipmentDoc[]> {
    return this.http.get<LetterEquipmentDoc[]>(`${environment.apiUrl}/technical-letters/letter-equipment-doc/${letterEquipmentId}`);
  }

  addLetterEquipmentDoc(equipment: LetterEquipmentDoc): Observable<any> {
    return this.http.post<LetterEquipmentDoc>(`${environment.apiUrl}/technical-letters/add-letter-equipment-doc`, equipment);
  }
}
